import React from 'react';
import { BOARD_MESSAGE_CONSTANT } from '../constants/MessageConstants';
import { hideMessage } from '../actions/MessageActions';
import { getI18NMessage } from 'I18N/I18NHelper';
import DialogsView from 'dg-react-dialogs';

class MessageView extends React.Component {
	constructor(props) {
		super(props);

		this.state = {};
		this.hideMessage = this.hideMessage.bind(this);
	}

	componentDidMount() {
        this.props.initMessageComp();
	}
	
	render() {
		if ( Object.keys(this.props).length === 0 || !this.props.messageData || !this.props.messageData.show ) {
			return false;
		}

		const messageData = this.props.messageData;
		const type = messageData.type;

		const config = {
			header: messageData.headerText,
			message: messageData.message,
			actionLabels: messageData.actionLabels,
			dontShowMeAgain: messageData.dontShowMeAgain,
			showMainBox: messageData.showMainBox,
			htmlMessage: messageData.htmlMessage,
			noHeaderIcon: true,
			type
		};

		return (
			<DialogsView config={ config } onSelection={ this.hideMessage } getI18NMessage={ getI18NMessage }/>
		);
	}

	 /* istanbul ignore next */
	hideMessage(confirmation, doNotShowAgain) {
		if ( this.props.messageData.onConfirmFn 
			&& this.props.messageData.type !== BOARD_MESSAGE_CONSTANT.TYPE_CONFIRMATION ) {
			this.props.messageData.onConfirmFn();
		}

		this.props.store.dispatch( hideMessage() );

		if ( confirmation && this.props.messageData.onConfirmFn ) {
			this.props.messageData.onConfirmFn(doNotShowAgain);
		} else if ( this.props.messageData.onCancelFn ) {
			this.props.messageData.onCancelFn(doNotShowAgain);
		}
	}
}

export default MessageView;